export var CardContainerVariantType;
(function (CardContainerVariantType) {
    CardContainerVariantType["INFORMATIVE_STANDARD"] = "INFORMATIVE_STANDARD";
    CardContainerVariantType["INFORMATIVE_COMPACT"] = "INFORMATIVE_COMPACT";
    CardContainerVariantType["INTERACTIVE_STANDARD"] = "INTERACTIVE_STANDARD";
    CardContainerVariantType["INTERACTIVE_COMPACT"] = "INTERACTIVE_COMPACT";
})(CardContainerVariantType || (CardContainerVariantType = {}));
//# sourceMappingURL=cardContainer.js.map